
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/accounts/practitioner-account/dashboard",
      function () {
        return require("private-next-pages/accounts/practitioner-account/dashboard/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/accounts/practitioner-account/dashboard"])
      });
    }
  